import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

/**
 * `applicationSubmitted` drives the post-submission confirmation modal: the guided
 * wizard lands here with it set rather than routing to `/confirmation`, and closing
 * the modal clears it.
 *
 * Same param name the legacy show controller uses, deliberately — manage is
 * replacing that screen, so the URL contract survives the swap.
 *
 * The route declares `replace: true` for it (see utils/tas/manage-route), so
 * clearing the flag does not leave a history entry that Back would re-open the
 * modal from.
 */
export default class TasApplicationsManageController extends Controller {
  @tracked applicationSubmitted: boolean = false;

  queryParams = ['applicationSubmitted'];
}
